<template>
  <a-modal
    :title="type == 'create' ? '付款凭证-上传' : '付款凭证-查看'"
    v-model="modalShow"
    width="80%"
    @cancel="close"
    destroyOnClose
    :class="{ 'footer-none': readonly }"
  >
    <a-spin :spinning="loading">
      <a-form-model
        class="common-form-inline"
        :rules="ruleForm"
        ref="ruleForm"
        :model="pageData"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 13 }"
      >
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="付款方" prop="payCstName">
              <a-input
                v-model="pageData.payCstName"
                placeholder="请输入"
                :disabled="readonly"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="付款账号" prop="payAccountNo">
              <a-input
                v-model="pageData.payAccountNo"
                placeholder="请输入"
                :disabled="readonly"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="开户行" prop="payOpenBank">
              <a-input
                v-model="pageData.payOpenBank"
                placeholder="请输入"
                :disabled="readonly"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="收款方" prop="receiveCstName">
              <a-input
                v-model="pageData.receiveCstName"
                placeholder="请输入"
                :disabled="readonly"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="收款账号" prop="receiveAccountNo">
              <a-input
                v-model="pageData.receiveAccountNo"
                placeholder="请输入"
                :disabled="readonly"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="开户行" prop="receiveOpenBank">
              <a-input
                v-model="pageData.receiveOpenBank"
                placeholder="请输入"
                :disabled="readonly"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="附件上传" prop="fileId">
              <fileUpload
                accept=".PNG,.png,.JPG,.jpg,.JPEG,.jpeg.pdf,.PDF"
                ref="fileUpload"
                :showList="[pageData.file]"
                :paramObj="uploadParam"
                @uploadOk="uploadOk"
                @handleFileRemove="removeOk"
                :disabled="readonly"
                name="file"
                :removeaction="true"
              />
              <div class="text-color-orange" style="white-space: nowrap;">注：附件支持图片及pdf格式，且大小不可超过20M</div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="text-color-orange" style="padding-left:86px;">
        提示：<br />
        上传付款凭证即代表祺信开立方承诺：祺信开立方已经支付了对应祺信款项，相应祺信的最终持票人已经收到了对应祺信金额的兑付，平台可据此对相应祺信进行已支付完毕处理。后续祺信持有人若对收款提出异议，由祺信开立方解决。
      </div>
    </a-spin>
    <template slot="footer" v-if="!readonly">
      <a-button class="btn-blue-line" @click="close()">取消</a-button>
      <button-load @clickHandle="save" type="primary" lable="保存" />
    </template>
  </a-modal>
</template>

<script>
import { fileSaveAPI, fileQueryAPI } from "@/api/file.js";
import {
  addPayVoucher,
  queryPayVoucherByGldId,
  updatePayVoucher
} from "@/api/pay.js";
export default {
  data() {
    return {
      type: "create",
      loading: false,
      modalShow: false,
      uploadParam: {
        app: "portal-pc",
        module: "payable",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: undefined,
        mdlId: "payable",
        fileTpCd: 6
      },
      pageData: {
        file: null,
        fileId: undefined,
        payCstName: undefined,
        payAccountNo: undefined,
        payOpenBank: undefined,
        receiveCstName: undefined,
        receiveAccountNo: undefined,
        receiveOpenBank: undefined
      },
      ruleForm: {
        payCstName: [
          { required: true, message: "付款方不能为空", trigger: "blur" }
        ],
        payAccountNo: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("付款账号不能为空");
              } else {
                cbfn();
              }
            }
          }
        ],
        payOpenBank: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("开户行不能为空");
              } else {
                cbfn();
              }
            }
          }
        ],
        receiveCstName: [
          { required: true, message: "收款方不能为空", trigger: "blur" }
        ],
        receiveAccountNo: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("收款账号不能为空");
              } else {
                cbfn();
              }
            }
          }
        ],
        receiveOpenBank: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("开户行不能为空");
              } else {
                cbfn();
              }
            }
          }
        ],
        fileId: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, cbfn) => {
              if (!this.pageData.fileId) {
                cbfn("请上附件");
              } else {
                cbfn();
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    readonly() {
      return this.type != "create";
    }
  },
  created() {},
  methods: {
    open(params = {}) {
      this.type = params.type || "create";
      this.modalShow = true;
      this.record = params.record || {};
      this.uploadParam.tblBlId = this.record.gldId;
      this.getInfo();
    },
    getInfo() {
      if (this.type == "create") {
        return;
      }
      this.loading = true;
      queryPayVoucherByGldId(this.record.gldId,{time:new Date().getTime()}).then(res => {
        this.pageData = res.data || {};
        this.loading = false;
        this.getFile();
      });
    },
    close() {
      this.pageData = {
        file: null,
        fileId: undefined,
        payCstName: undefined,
        payAccountNo: undefined,
        payOpenBank: undefined,
        receiveCstName: undefined,
        receiveAccountNo: undefined,
        receiveOpenBank: undefined
      };
      this.$refs.ruleForm.resetFields();
      this.modalShow = false;
    },
    // 删除文件
    removeOk() {
      this.pageData.file = null;
      this.pageData.fileId = undefined;
    },
    getFile() {
      fileQueryAPI({
        tblBlId: this.uploadParam.tblBlId,
        fileTpCd: this.uploadParam.fileTpCd
      })
        .then(res => {
          this.$set(
            this.pageData,
            "file",
            res.data.length > 0 ? res.data[0] : {}
          );
          this.$set(this.pageData, "fileId", this.pageData.file.fileId);
        })
        .catch(err => {
          console.log(err);
        });
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.uploadParam.tblBlId,
        fileTpCd: this.uploadParam.fileTpCd,
        mdlId: "payable"
      };
      this.loading = true;
      fileSaveAPI(param)
        .then(res => {
          this.loading = false;
          this.pageData.fileId = res.data.fileId;
          this.pageData.file = data;
          this.$refs.ruleForm && this.$refs.ruleForm.validateField("fileId");
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    uploadOk(resList) {
      this.fileSave(resList[0]);
    },
    save(btn) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            ...this.pageData,
            gldId: this.record.gldId,
            fileType: this.uploadParam.fileTpCd
          };
          delete params.file;
          addPayVoucher(params)
            .then(res => {
              this.$message.success("操作成功");
              btn && btn.closeLoad();
              this.close();
              this.$emit("success");
            })
            .catch(err => {
              btn && btn.closeLoad();
            });
        } else {
          btn && btn.closeLoad();
        }
      });
    }
  },
  watch: {},
  activated() {}
};
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-payment/uploadVoucherDialog.vue